import { ProductUpdatesSubscriptionsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useGetProductUpdatesSubscriptions = () => {
  const { data, loading, refetch } = useQuery(ProductUpdatesSubscriptionsDocument, {})

  return {
    loading,
    refetch,
    productUpdatesSubscriptions: data?.productUpdates.subscriptionsConnection.nodes,
  }
}
